<!-- 列表详情组件 -->
<template>
  <div class="detail">
    <component
      ref="detailComponent"
      :is="datas.moduleStyleType == 1 ? 'detail1' : 'detail2'"
      :datas="datas"
    />
    <!-- <div class="detail-header" v-html="detailData.description"></div> -->
  </div>
</template>

<script>
// 引入事件总线
import Bus from "@/utils/bus.js";
export default {
  name: "detail",
  props: {
    datas: Object,
  },
  data() {
    return {
      detailData: {},
    };
  },
  mounted() {
    // 监听自定义事件，接收数据
    // 格式：Bus.$on('事件名', (接收的参数) => { 处理逻辑 })
    Bus.$on("send-message", (data, update) => {
      this.datas.moduleStyleType = data.moduleStyleType;
      console.log(
        "组件B1111111111111detail组件接收到的数据：",
        data,
        update,
        this.datas,
      );
    });
    // Bus.$on("update-message", (data) => {
    //   // this.datas.moduleStyleType =data.linkDetail? data.linkDetail.moduleStyleType:this.datas.moduleStyleType;
    //   console.log(
    //     "组件B1111111111111detail组件接收到的数据更新更新更新：",
    //     data,
    //     this.datas,
    //   );
    // });
  },
  // 重要：组件销毁时移除事件监听，避免内存泄漏
  beforeDestroy() {
    Bus.$off("send-message");
  },
  created() {
    console.log(
      "详情父组件create了------------------------------------------",
      this.datas,
    );
    // 详情模块类型初始化
    this.datas.moduleStyleType = 1;
    // 获取文章详情
    // this.getArticleDetail();
  },
  methods: {
    // 获取文章详情
    async getArticleDetail() {
      const res = await this.$api.admin.article.getArticleDetailAPI({
        id: this.$route.query.pageId,
      });
      if (res.data.code === 200) {
        console.log(
          "获取文章详情结果",
          this.$route.query,
          res.data,
          this.$refs.detailComponent,
        );
        this.detailData = res.data.data;
      }
    },
  },
};
</script>
<style scoped lang="scss">
.detail {
  height: 100%;
  .detail-header {
    padding: 20px;
  }
}
</style>
